/**
 * Talewave 品牌 - Welfare 页面 配置
 */
import { welfareCommonConfig } from './common'
import type { WelfarePageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

export const theme = {
  btnBg: '#F6F4FB',
  btnText: brandTheme.primaryColor,
  coinsColor: brandTheme.primaryColor,
} as const

export const resources = {
  homeBg: '/images/talewave/home-bg.webp',
  welfareGold: '/images/talewave/welfare-gold.png',
  welfareBox: '/images/talewave/welfare-box.png',
} as const

export const welfareConfig: WelfarePageConfig = {
  theme,
  resources,
  texts: welfareCommonConfig.texts,
}
